/**
 * Used to reset pinia stores in different cases
 */
export function useResetStores() {
    /**
     * Reset stores of buying process (without esav)
     * ----------------------------------------------------------------------------
     * - Reset OFFER FLOW
     * - Reset CHECKOUT
     *
     * Used on completing a buy process (after payment)
     */
    function resetBuyProcessStores() {
        _clearOfferFlowStores();
        _clearCheckoutStores();
        safeLocalStorage.setItem('tot_last_interaction', zurichDate().toISOString());
    }

    /**
     * Reset a single offer flow
     * ----------------------------------------------------------------------------
     * - Reset OFFER FLOW
     *
     * Used on "fresh START" a new offer flow
     */
    function resetOfferFlow() {
        _clearOfferFlowStores();
        try {
            safeLocalStorage.setItem('tot_last_interaction', zurichDate().toISOString());
        }
        catch (error) {
        }
    }

    /**
     * Reset ALL stores
     * ----------------------------------------------------------------------------
     * Used for dev
     */
    function resetAllStores() {
        _clearOfferFlowStores();
        _clearCheckoutStores();
        _clearEsavStores();
        safeLocalStorage.setItem('tot_last_interaction', zurichDate().toISOString());
    }

    /**
     * ------------------------------------------------------------------------------------------
     * Internal functions to clear specific store groups
     * ------------------------------------------------------------------------------------------
     */

    /**
     * Clear offer flow stores (product, passenger)
     */
    function _clearOfferFlowStores() {
        useProductStore().reset();
        usePassengerStore().reset();
        safeLocalStorage.removeItem('product');
        safeLocalStorage.removeItem('passenger');
        logDebugProductChanges('Reset product + passenger store');
        logSentryBreadcrumb('Reset product + passenger store');
    }

    /**
     * Clear checkout stores (cart, address, booking)
     */
    function _clearCheckoutStores() {
        useCartStore().reset();
        useAddressStore().reset();
        useBookingStore().reset();
        safeLocalStorage.removeItem('cart');
        safeLocalStorage.removeItem('address');
        safeLocalStorage.removeItem('booking');
        logDebugProductChanges('Reset cart, address, booking store');
        logSentryBreadcrumb('Reset cart, address, booking store');
    }

    /**
     * Clear esav stores (exchange, refund)
     */
    function _clearEsavStores() {
        useExchangeStore().reset();
        useRefundStore().reset();
        safeLocalStorage.removeItem('exchange');
        safeLocalStorage.removeItem('refund');
        logDebugProductChanges('Reset exchange, refund store');
        logSentryBreadcrumb('Reset exchange, refund store');
    }

    return {
        resetOfferFlow,
        resetBuyProcessStores,
        resetAllStores,
    };
}
